<template>
  <li class="my-3 bg-white rounded-lg">
    <button
      class="flex items-center w-full px-4 py-2 text-gray-600 hover:text-red-700 transition-transform transform rounded-md hover:translate-x-1 focus:outline-none focus:ring"
      :data-bs-target="`#${category.slug}Collapse`"
      data-bs-toggle="collapse"
    >
      <span class="ml-2 font-medium ">{{category.name}}</span>
      <span class="ml-auto">
        <svg
          class="w-4 h-4 transition-transform"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </span>
    </button>
    <ul
    v-if="category.children_recursive.length"
    class="collapse" :id="`${category.slug}Collapse`">
      <SubCategories
      v-for="subCategory in category.children_recursive"
      :key="subCategory.id"
      :subCategory="subCategory" />
    </ul>
    <ul
    v-else
    class="collapse" :id="`${category.slug}Collapse`">
      <li>
        <button
          @click.prevent="switchCategory(category)"
          class="flex px-6 py-2 font-medium text-gray-600 hover:text-red-700 transition-transform transform hover:translate-x-1"
          >{{ _.capitalize(category.name) }}</button
        >
      </li>
    </ul>
  </li>
</template>

<script>
import SubCategories from './SubCategories.vue'
import _ from 'lodash'

export default {
  components: { SubCategories },
  name: 'Categories',
  props: ['category'],
  methods: {
    switchCategory (category) {
      const payload = {
        id: category.id,
        categorySlug: category.slug,
        page: 1,
        sort: false
      }
      this.$store.dispatch('fetchTenants', payload)
    }
  },
  computed: {
    _ () {
      return _
    },
    page () {
      return this.$store.state.page
    }
  }
}
</script>

<style>

</style>
